import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedLayout } from "@/app/ProtectedLayout";
import { PreferencesPage } from "@/components/account/PreferencesPage";
import { AdminPage } from "@/components/admin/AdminPage";
import { PlansPage } from "@/components/admin/PlansPage";
import { ForgotPasswordPage } from "@/components/auth/ForgotPasswordPage";
import { LoginPage } from "@/components/auth/LoginPage";
import { ResetPasswordPage } from "@/components/auth/ResetPasswordPage";
import { VerifyAccountPage } from "@/components/auth/VerifyAccountPage";
import { VerifyEmailPage } from "@/components/auth/VerifyEmailPage";
import { PublicOnboardingRoute } from "@/components/onboarding/PublicOnboardingRoute";
import { ClientDetail } from "@/components/clients/ClientDetail";
import { ClientsPage } from "@/components/clients/ClientsPage";
import { ContractDetail } from "@/components/contracts/ContractDetail";
import { ContractsPage } from "@/components/contracts/ContractsPage";
import { FaturamentoPage } from "@/components/faturamento/FaturamentoPage";
import { HomePage } from "@/components/home/HomePage";
import { SubjectRequestPage } from "@/components/lgpd/SubjectRequestPage";
import { OperacaoPage } from "@/components/operacao/OperacaoPage";
import { OrganizationDetail } from "@/components/organizations/OrganizationDetail";
import { OrganizationsPage } from "@/components/organizations/OrganizationsPage";
import { WorkspaceDetailPage } from "@/components/workspaces/WorkspaceDetailPage";
import { WorkspacesListPage } from "@/components/workspaces/WorkspacesListPage";

function NotFoundPage() {
  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", textAlign: "center" }}>
      <div>
        <h1 className="td-h1">404</h1>
        <p className="td-body">Página não encontrada</p>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verificar-email" element={<VerifyEmailPage />} />
      <Route path="/accept-invite/:token" element={<PublicOnboardingRoute />} />
      <Route path="/privacidade/solicitar" element={<SubjectRequestPage />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/verificar" element={<VerifyAccountPage />} />
        <Route path="/workspaces" element={<WorkspacesListPage />} />
        <Route path="/workspaces/:id" element={<WorkspaceDetailPage />} />
        <Route path="/organizacoes" element={<OrganizationsPage />} />
        <Route path="/organizacoes/:id" element={<OrganizationDetail />} />
        <Route path="/empresas" element={<ClientsPage />} />
        <Route path="/empresas/:id" element={<ClientDetail />} />
        <Route path="/operacao" element={<OperacaoPage />} />
        <Route path="/contratos" element={<ContractsPage />} />
        <Route path="/contratos/:id" element={<ContractDetail />} />
        <Route path="/faturamento" element={<FaturamentoPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/plans" element={<PlansPage />} />
        <Route path="/preferencias" element={<PreferencesPage />} />
        {/* Rotas antigas consolidadas em /preferencias */}
        <Route path="/account/sessions" element={<Navigate to="/preferencias" replace />} />
        <Route path="/account/security" element={<Navigate to="/preferencias" replace />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
